import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from '../shared/validators/CustomValidators';

@Component({
  selector: 'app-signup-coach',
  templateUrl: './signup-coach.component.html',
  styleUrls: ['./signup-coach.component.scss']
})
export class SignupCoachComponent implements OnInit {
  formSubmitting=false;
  countries:any=[];
  plans:any;
  maxBirthdayDate = new Date();

  coachForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    re_password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    last_name: ['', Validators.compose([Validators.required])],
    dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
    country: ['', Validators.compose([Validators.required])],
    gym_name: ['', Validators.compose([Validators.required])],
    plan:['',Validators.compose([Validators.required])],
    trial:[0],
    form_type: ['coach']
  },
  { validators: CustomValidators.MatchValidator('password', 're_password') });

  constructor(private route: ActivatedRoute,private fb: FormBuilder, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {
    this.getCountries()
    this.getPlans()
    this.coachForm.get('trial').valueChanges.subscribe(val => {
      if (val==0) {
        this.coachForm.controls['plan'].setValidators([Validators.required]);
      } else {
        this.coachForm.controls['plan'].clearValidators();
      }
      this.coachForm.controls['plan'].updateValueAndValidity();
    },
    error => {
      this.toastrService.error("unable to handle response");
      this.formSubmitting=false;
    });
    this.maxBirthdayDate.setFullYear( this.maxBirthdayDate.getFullYear() - 18 );
  }

  ngOnInit() {
  }


  onSigup(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      form.value.dob = this.webApi.formatDate(form.value.dob)
      if(form.value.plan==""){
        form.value.trial=1
      }
      let trial=form.value.trial
      this.webApi.signup(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          if(trial!=1 && data.redirecturl && data.redirecturl!=""){
            window.location.href=data.redirecturl;
          }
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  getCountries(){
    this.webApi.getCountries().subscribe((data: any) => {
      if (data.success) {
        this.countries=data.countries;
        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        alert(data.message)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }
  
  getPlans(){
    this.webApi.getPlans('coach').subscribe((data: any) => {
      if (data.success) {
        let dataplans=data.plans;
        this.plans = [];
        let count=0;
        for(let i=0; i<dataplans.length;i++){
          if(dataplans[i].title.indexOf('Novice-Median')!=-1){
            if(!this.plans['0']){
              this.plans['0']=[];
            }
            this.plans['0'][count]=[];
            this.plans['0'][count]['title']=dataplans[i].title
            this.plans['0'][count]['plan']=dataplans[i]
            this.plans['0'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Advanced')!=-1){
            if(!this.plans['1']){
              this.plans['1']=[];
            }
            this.plans['1'][count]=[];
            this.plans['1'][count]['title']=dataplans[i].title
            this.plans['1'][count]['plan']=dataplans[i]
            this.plans['1'][count]['index']=i
          }else if(dataplans[i].title.indexOf('Novice-Premier')!=-1){
            if(!this.plans['2']){
              this.plans['2']=[];
            }
            this.plans['2'][count]=[];
            this.plans['2'][count]['title']=dataplans[i].title
            this.plans['2'][count]['plan']=dataplans[i]
            this.plans['2'][count]['index']=i
          }
          count++;
        }

        if(this.plans['0']){
          this.plans['0'] = this.plans['0'].filter((val:any)=>{return val});
        }
        
        if(this.plans['1']){
          this.plans['1'] = this.plans['1'].filter((val:any)=>{return val});
        }

        if(this.plans['2']){
          this.plans['2'] = this.plans['2'].filter((val:any)=>{return val});
        }

        this.plans = this.plans.filter((val:any)=>{return val});

        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
      } else {
        this.toastrService.error(data.message);
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  get f1(): { [key: string]: AbstractControl } {
    return this.coachForm.controls;
  }
}


